import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";

import swal from "sweetalert";

import Sidebar from "../../myfin_v2/elements/Sidebar";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import workSpaceCss from "../../myfin_v2/css/workSpaceOverView.module.css";
import standaloneCss from "../../myfin_v2/css/standalone.module.css";
import FSCss from "../../myfin_v2/css/overview.module.css";

import Loading from "../../Components/Common/Loader/Loading";
import LoaderTwo from "../../Components/Common/Loader/LoaderTwo";
import DotIndicatorSVGComponent from "../../Components/Common/SVGComponents/DotIndicatorSVGComponent";
import buttoncss from "../../myfin_v2/css/button.module.css";
import { Button } from "../../myfin_v2/elements/Button";

import { ReactComponent as LeftArrowIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as GreenDot } from "../../myfin_v2/assets/icons/greenDotSmall.svg";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/search.svg";
import {ReactComponent as CloseIcon} from "../../myfin_v2/assets/icons/close_grey.svg";
import {
  getRegisterRelatedPartyDetailsApiHandler,
  setRegisterRelatedPartyDetailsApiHandler,
} from "../../WorkSpace/Components/ApiServices/apiHandler";
import InputGroup from "../../myfin_v2/elements/InputGroup";

const FSTopBar = ({ handleSave }) => {
  const history = useHistory();

  return (
    <div className={FSCss.w100}>
      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
          <div className={FSCss.iconContainer} style={{ paddingLeft: "0", width: "30px" }}>
            <LeftArrowIcon
              className="clickable"
              onClick={() => history.push(`/link-register`)}
              style={{ marginTop: "1px" }}
            />
          </div>

          <div className={FSCss.topBarHeading}>Workspace</div>
          <div className={FSCss.iconDotContainer}>
            <GreenDot />
          </div>

          <div className={FSCss.topBarHeading}>
            Standalone Financial Statements
          </div>
          <div className={FSCss.iconDotContainer}>
            <GreenDot />
          </div>

          <div className={FSCss.topBarSubHeading}>Tag Codes</div>
        </div>
        <div className={FSCss.headerRightContainer}>
          <button
          style={{
            width: "70px",
            height: "30px",
            backgroundColor: "#205A46",
            color: "#FFFFFF",
            borderRadius: "10px",
            padding: "20px 13px",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 400,
          }}
          onClick={handleSave}
        >
          Save
        </button> 
        </div>
      </div>
    </div>
  );
};

const TagCodes = () => {
  const { regType, regId } = useParams();

  const project_id = localStorage.getItem("project_id");
  const apiParams = {
    projectID: project_id,
    registerType: regType,
    registerID: regId,
  };

  const [tagCodesData, setTagCodesData] = useState({
    mappedRelatedParties: [],
    mappedCustCodes: [],
  });

  const [tagCodes, setTagCodes] = useState([]);
  const [draggedData, setDraggedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dropLoading, setDropLoading] = useState(false);

  const [relatedParties, setRelatedParties] = useState([]);
  const [customerCodes, setCustomerCodes] = useState([]);
  const [relatedPartySearch, setRelatedPartySearch] = useState("");
  const [customerCodeSearch, setCustomerCodeSearch] = useState("");

  const EMPTY_TAG_ROW = {
    mappedRelatedParties: [],
    mappedCustCodes: [],
  };

  useEffect(() => {
    getManualRelatedPartyDetails();
  }, []);

  // const getManualRelatedPartyDetails = () => {
  //   getRegisterRelatedPartyDetailsApiHandler(apiParams)
  //     .then((response) => {
  //       if (response?.data?.success === true) {
  //         setRelatedParties(response?.data?.relatedPartyNameList ?? []);
  //         setCustomerCodes(response?.data?.customerCodeList ?? []);
  //       } else {
  //         swal(
  //           "Error",
  //           response?.data?.error ||
  //             "Unable to get register related party details",
  //           "error",
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       swal(
  //         "Error",
  //         error?.response?.data?.error ||
  //           "Unable to populate register related party details",
  //         "error",
  //       );
  //     });
  // };
  const getManualRelatedPartyDetails = () => {
  getRegisterRelatedPartyDetailsApiHandler(apiParams)
    .then((response) => {
      if (response?.data?.success === true) {

        const parties = response.data.relatedPartyNameList ?? [];
        const codes = response.data.customerCodeList ?? [];
        const mapping = response.data.relatedPartyMapping ?? [];

        setRelatedParties(parties);
        setCustomerCodes(codes);

        if (mapping.length > 0) {
          const restoredRows = mapping.map(item => ({
            mappedRelatedParties: parties.filter(
              p => p.name === item.relatedPartyName
            ),
            mappedCustCodes: item.customerCodes ?? []
          }));

          setTagCodes(restoredRows);
        } else {
          setTagCodes([{ ...EMPTY_TAG_ROW }]);
        }

      } else {
        swal(
          "Error",
          response?.data?.error ||
            "Unable to get register related party details",
          "error"
        );
      }
    })
    .catch((error) => {
      swal(
        "Error",
        error?.response?.data?.error ||
          "Unable to populate register related party details",
        "error"
      );
    });
};

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setTagCodesData({
  //       mappedRelatedParties: relatedParties,
  //       mappedCustCodes: customerCodes,
  //     });
  //     setTagCodes([{ ...EMPTY_TAG_ROW }]);
  //     setLoading(false);
  //   }, 500);
  // }, [relatedParties, customerCodes]);
  useEffect(() => {
  setTagCodesData({
    mappedRelatedParties: relatedParties,
    mappedCustCodes: customerCodes,
  });
}, [relatedParties, customerCodes]);


  const AddNewItem = () => {
    setTagCodes((prev) => [...prev, { ...EMPTY_TAG_ROW }]);
  };

  const handleDragStart = (e, ele, source) => {
    setDraggedData({ value: ele, __source: source });
  };

  const handleDrop = (e, key, index) => {
    e.preventDefault();
    if (!draggedData) return;

    if (draggedData.__source !== key) {
      swal(
        "Invalid Drop",
        "This item cannot be dropped in this category.",
        "warning",
      );
      return;
    }

    setDropLoading(true);

    setTagCodes((prev) => {
      const updated = [...prev];

      if (key === "mappedRelatedParties") {
        updated[index][key] = [draggedData.value];
      } else {
        if (!updated[index][key].includes(draggedData.value)) {
          updated[index][key] = [...updated[index][key], draggedData.value];
        }
      }

      return updated;
    });

    setDraggedData(null);
    setDropLoading(false);
  };

  const RemoveItem = (element, key, index) => {
    setTagCodes((prev) => {
      const updated = [...prev];

      if (key === "mappedRelatedParties") {
        updated[index][key] = [];
      } else {
        updated[index][key] = updated[index][key].filter(
          (item) => item !== element,
        );
      }

      return updated;
    });
  };

  const buildPayload = () => {
    const filteredRows = tagCodes.filter(
      (row) =>
        row.mappedRelatedParties.length > 0 || row.mappedCustCodes.length > 0,
    );

    if (filteredRows.length === 0) {
      swal(
        "Error",
        "Please map at least one Related Party and Customer code.",
        "error",
      );
      return;
    }

    const isValid = filteredRows.every(
      (row) =>
        row.mappedRelatedParties.length === 1 &&
        row.mappedCustCodes.length >= 1,
    );

    if (!isValid) {
      swal(
        "Error",
        "Each mapped row must have 1 related party and at least 1 Customer ID.",
        "error",
      );
      return;
    }

    console.log("tagCodes", tagCodes);

    return {
      relatedPartyMapping: tagCodes
        .map((row) => ({
          relatedPartyName: row.mappedRelatedParties[0]?.name ?? null,
          customerCode: row.mappedCustCodes ?? [],
        }))
        // remove ONLY { relatedPartyName: null, customerCode: [] }
        .filter(
          (item) =>
            !(
              item.relatedPartyName === null &&
              Array.isArray(item.customerCode) &&
              item.customerCode.length === 0
            ),
        ),
    };
  };

  const handleSave = () => {
    const hasAnyRelatedParty = tagCodes.some(
      (row) => row.mappedRelatedParties.length > 0,
    );

    if (!hasAnyRelatedParty) {
      swal(
        "Error",
        "Please map at least one Related Party before saving.",
        "error",
      );
      return;
    }

    const payload = buildPayload();

    if (!payload) return;

    setRegisterRelatedPartyDetailsApiHandler(apiParams, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          swal(
            "Register related party details updated successfully",
            "",
            "success",
          );
        } else {
          swal(
            "Error",
            response?.data?.error ||
              "Unable to updated register related party details",
            "error",
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error ||
            "Unable to updated register related party details",
          "error",
        );
      });
  };

  const filteredRelatedParties = tagCodesData.mappedRelatedParties.filter(
    (item) => {
      const search = relatedPartySearch.toLowerCase();

      return (
        item.name?.toLowerCase().includes(search) ||
        item.relatedPartyType?.toLowerCase().includes(search)
      );
    },
  );

  const filteredCustomerCodes = tagCodesData.mappedCustCodes.filter((code) =>
    code?.toLowerCase().includes(customerCodeSearch.toLowerCase()),
  );

  return (
    <div className={workSpaceCss.df}>
      <Sidebar />

      <div className={`d-flex ${commoncss.pageContent}`}>
        <div className={bookclosurecss.bookClosureContent}>
          <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
            <FSTopBar handleSave={handleSave} />
          </div>

          <div style={{ height: "90vh", overflow: "auto" }}>
            {loading ? (
              <Loading />
            ) : (
              <div className="d-flex bg-transparent mb-2">
                {/* LEFT */}
                <div className="col-sm-3" style={{ paddingLeft: "20px", paddingRight: "10px" }}>
                  <div className="radius-10px mt-3 border bg-white">
                    <p className={`m-0 border-bottom ${commoncss.fs16}`} style={{ padding: "10px 18px", fontWeight: "100" }}>
                      Related Party Names
                    </p>

                    <div
                      className={`p-3 ${commoncss.dFlexClm}`}
                      style={{ gap: "10px", height: "81vh", overflow: "auto" }}
                    >
                      <InputGroup
                        width={"100%"}
                        class_="mb-0"
                        inputs={[
                          <>
                            <span className={commoncss.imgIconInput}>
                              <span
                                className="icon"
                                style={{
                                  cursor: "pointer",
                                  pointerEvents: "auto",
                                  marginTop: "-3px",
                                  paddingRight: "4px"
                                }}
                              >
                                <SearchIcon
                                  className="vaMiddle"
                                  width={17}
                                  height={17}
                                />
                              </span>
                              <input
                                type="text"
                                value={relatedPartySearch}
                                placeholder="Search related party"
                                onChange={(e) =>
                                  setRelatedPartySearch(e.target.value)
                                }
                              />
                            </span>
                          </>,
                        ]}
                      />
                      <div style={{ padding: "6px 0", display: "flex", flexDirection: "column",  gap: "12px" }}>
                      {filteredRelatedParties.map((tagItem, i) => (
                        <div
                          key={i}
                          draggable
                          onDragStart={(e) =>
                            handleDragStart(e, tagItem, "mappedRelatedParties")
                          }
                          className={`${standaloneCss.taggedAssets} d-flex align-items-center`}
                          style= {{ padding: "0 20px"}}
                        >
                          <DotIndicatorSVGComponent
                            color="#ccd5d3"
                            height={21}
                            width={13}
                          />
                          <div
                            className={`m-0 ml-4 ${commoncss.dFlexClm}`}
                            style={{ gap: "3px"}}
                          >
                            <span
                              className={`${commoncss.label6}  ${commoncss.fs15}`}
                            >
                              {tagItem.name}
                            </span>
                            <span
                              className={`text-uppercase ${commoncss.label3} ${commoncss.fs12} ${commoncss.fw600}`}
                              style={{ letterSpacing: "1px"}}
                            >
                              {tagItem.relatedPartyType}
                            </span>
                          </div>
                        </div>
                      ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* CENTER */}
                <div className="col-sm-6 px-2" style={{ marginTop: "17px"}}>
                  <div className="text-center">
                    {dropLoading && <LoaderTwo />}
                  </div>
                  <div className={`${commoncss.dFlexJustifysb} mb-3`}>
                    <p className="m-0 px-1 py-2 font-size-17">
                      Map Registers to your Financial Statement
                    </p>
                    <Button
                      btnColor={buttoncss.secondary}
                      style= {{ background: "transparent"}}
                      icon={<PlusIcon />}
                      label="Add Slot"
                      onClick={AddNewItem}
                    />
                  </div>
                  <div
                    className="border radius-10px bg-white px-1 pt-2 pb-3"
                    style={{ height: "auto", overflow: "auto" }}
                  >
                    <div className="d-flex mt-3 mb-1 px-2" style={{ gap: "10px" }}>
                      <span className={`${commoncss.primaryLabel1}`} style={{ flex: 1 }}>
                        Map Related Party
                      </span>
                      <span className={`${commoncss.primaryLabel1}`} style={{ flex: 1, paddingRight: "20px" }}>
                        Map Customer
                      </span>
                    </div>
                    {tagCodes.map((tag, tx) => (
                      <div key={tx} className="px-2 pb-2">
                        <div className="d-flex" style={{ gap: "10px" }}>
                          {/* RELATED PARTIES DROP */}
                          <div
                            className={standaloneCss.dragDropAreaTagAssets}
                             style={{
                              position: "relative",
                              borderRadius: "8px",
                              padding: "0",
                              textAlign: "left",
                              backgroundColor: "#F4FAF5",
                              height: "70px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              flex: 1,
                              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23A0DABC' stroke-width='2' stroke-dasharray='12 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) =>
                              handleDrop(e, "mappedRelatedParties", tx)
                            }
                          >
                            {tag.mappedRelatedParties.length === 0 ? (
                              <span
                                style={{ color: "#B3C0BD", fontSize: "14px" }}
                              >
                                Drop Related Party here
                              </span>
                            ) : (
                              tag.mappedRelatedParties.map((tagItem, ax) => (
                                <div
                                  key={ax}
                                  className="d-flex align-items-center justify-content-between"
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: "2px" }}
                                  >
                                    <div
                                      className={`m-0 ml-3 ${commoncss.dFlexClm}`}
                                      style={{ gap: "2px" }}
                                    >
                                      <span
                                        className={`${commoncss.label6}  ${commoncss.fs15}`}
                                      >
                                        {tagItem.name}
                                      </span>
                                      <span
                                        className={`text-uppercase ${commoncss.label3} ${commoncss.fs12} ${commoncss.fw600}`}
                                        style={{ letterSpacing: "1px" }}
                                      >
                                        {tagItem.relatedPartyType}
                                      </span>
                                    </div>
                                  </div>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      paddingRight: "20px",
                                    }}
                                    onClick={() =>
                                      RemoveItem(
                                        tagItem,
                                        "mappedRelatedParties",
                                        tx,
                                      )
                                    }
                                  >
                                    <CloseIcon/>
                                  </span>
                                </div>
                              ))
                            )}
                          </div>

                          {/* CUSTOMER CODE DROP */}
                          <div
                            className={standaloneCss.dragDropAreaTagAssets}
                            style={{
                              position: "relative",
                              borderRadius: "8px",
                              padding: "7px 10px ",
                              textAlign: "left",
                              backgroundColor: "#F4FAF5",
                              height: "70px",
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                              justifyContent: "space-evenly",
                              border: "none",
                              flex: 1,
                              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23A0DABC' stroke-width='2' stroke-dasharray='12 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, "mappedCustCodes", tx)}
                          >
                            {tag.mappedCustCodes.length === 0 ? (
                              <span
                                style={{ color: "#B3C0BD", fontSize: "14px" }}
                              >
                                Drop customer codes here
                              </span>
                            ) : (
                              tag.mappedCustCodes.map((tagItem, ax) => (
                                <div
                                  key={ax}
                                  className="d-flex align-items-center justify-content-between"
                                  style={{
                                    width: "100%",
                                    padding: "12px 14px",
                                    borderRadius: "12px",
                                    background: "#F5FBF8",
                                    border: "1px solid #8FD3B6",
                                    minHeight: "56px"
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: "2px" }}
                                  >
                                    <div
                                      className={`m-0 ml-3 ${commoncss.dFlexClm}`}
                                      style={{ gap: "2px" }}
                                    >
                                      <span
                                        className={`${commoncss.label6}  ${commoncss.fs15}`}
                                        style={{ letterSpacing: "1px"}}
                                      >
                                        {tagItem}
                                      </span>
                                    </div>
                                  </div>

                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      marginTop: "-2px",
                                      //paddingRight: "20px",
                                    }}
                                    onClick={() =>
                                      RemoveItem(tagItem, "mappedCustCodes", tx)
                                    }
                                  >
                                    <CloseIcon/>
                                  </span>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* RIGHT */}
                <div className="col-sm-3 px-2">
                  <div className="radius-10px mt-3 border bg-white">
                    <p className={`m-0  border-bottom ${commoncss.fs16}`} style={{ padding: "10px 18px", fontWeight: "100" }}>
                      Customer Codes
                    </p>

                    <div
                      className={`p-3 ${commoncss.dFlexClm}`}
                      style={{ gap: "10px", height: "81vh", overflow: "auto" }}
                    >
                      <InputGroup
                        width={"100%"}
                        class_="mb-0"
                        inputs={[
                          <>
                            <span className={commoncss.imgIconInput}>
                              <span
                                className="icon"
                                style={{
                                  cursor: "pointer",
                                  pointerEvents: "auto",
                                  marginTop: "-3px",
                                  paddingRight: "4px",
                                }}
                              >
                                <SearchIcon
                                  className="vaMiddle"
                                  width={17}
                                  height={17}
                                />
                              </span>
                              <input
                                type="text"
                                value={customerCodeSearch}
                                placeholder="Search customer code"
                                onChange={(e) =>
                                  setCustomerCodeSearch(e.target.value)
                                }
                              />
                            </span>
                          </>,
                        ]}
                      />
                      <div style={{ padding: "6px 0", display: "flex", flexDirection: "column", gap: "10px" }}>
                      {filteredCustomerCodes.map((tagItem, i) => (
                        <div
                          key={i}
                          draggable
                          onDragStart={(e) =>
                            handleDragStart(e, tagItem, "mappedCustCodes")
                          }
                          className={`${standaloneCss.taggedAssets} d-flex align-items-center`}
                          style= {{ padding: "0 20px"}}
                        >
                          <DotIndicatorSVGComponent
                            color="#CCD5D3"
                            height={21}
                            width={13}
                          />
                          <div
                            className={`m-0 ml-3 ${commoncss.dFlexClm}`}
                            style={{ gap: "2px" }}
                          >
                            <span
                              className={`${commoncss.label6}  ${commoncss.fs15}`}
                            >
                              {tagItem}
                            </span>
                          </div>
                        </div>
                      ))}
                     </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagCodes;
